module.exports = __webpack_public_path__ + "img/weizhiwenjian.3ad0bc5f.svg";